module.exports = __webpack_public_path__ + "static/media/collaboration_app-icon.eb6e3cc7.png";